<div class="duna-event-ics-container">
  @if (loading) {
  <div class="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Henter event...</p>
  </div>
  } @if (error && !loading) {
  <div class="error">
    <p>{{ error }}</p>
  </div>
  } @if (event && !loading) {
  <div class="content">
    <h1>Tilføj dette event til din kalender</h1>
    <p class="event-title">{{ getEventTitle() }}</p>
    <button mat-flat-button color="primary" (click)="downloadIcs()">
      Download .ics
    </button>
    <p class="hint">
      Klik for at downloade en .ics-fil, som du kan åbne i din kalenderapp
      (Outlook, Google Kalender, Apple Kalender m.fl.).
    </p>
  </div>
  }
</div>
